import {csv as d3csv, json as d3json} from 'd3-request';
import * as topojson from 'topojson-client';
import * as _ from 'underscore';

// import * as App from '../App/App';
import Dispatch from '../Dispatch/Dispatch';

// console.log('model module', Dispatch.dispatch);

var dataNamesToNaturalEarthNames = {
	'Congo': 'Republic of Congo',
	"Korea, Democratic People's Republic of": 'Dem. Rep. Korea',
	'Gambia': 'The Gambia',
	'Kyrgyz Republic': 'Kyrgyzstan',
	"Lao People's Democratic Republic": 'Lao PDR',
	'Sudan, North': 'Sudan',
	'Sudan, South': 'South Sudan',
	'Republic of Moldova': 'Moldova',
	'Russia': 'Russian Federation',
	'Tanzania, United Republic of': 'Tanzania',
	'Sao Tome and Principe': 'São Tomé and Principe',
	"C™te d'Ivoire": "Côte d'Ivoire"
};

function cleanCsv(csv) {
	_.each(csv, function(row) {
		row.Country = row.Country.trim();

		if(dataNamesToNaturalEarthNames[row.Country] !== undefined)
			row.Country = dataNamesToNaturalEarthNames[row.Country];
	});
}

function makeLookup(csv) {
	var ret = {};
	_.each(csv, function(row) {
		ret[row.Country] = row;
	});
	return ret;
}

// function checkAllCountryRowsAreInGeoJson(csv, geoJson) {
// 	_.each(geoJson.features, function(feature) {
// 		var country = feature.properties.name_long;
// 		if(csv[country] !== undefined)
// 			csv[country].hasGeoJson = true;
// 	});

// 	// _.each(csv, function(country) {
// 	// 	if(country.hasGeoJson === undefined) {
// 	// 		console.log(country, 'has no geojson')
// 	// 	}
// 	// });
// }

var api = {
	worldJson: null,
	data: null,
	dataLU: null,

	load: function() {

		d3json('data/world.json?2', function(err, json) {
			// console.log('topojson received');
			api.worldJson = topojson.feature(json, json.objects.ne_50m_admin_0_countries);
			// App.update('map');
			Dispatch.dispatch.call('mapBoundariesReady');			

			// if(api.dataLU !== null)
			// 	checkAllCountryRowsAreInGeoJson(api.dataLU, api.worldJson);
		});

		d3csv('data/world.csv?2', function(err, csv) {
			cleanCsv(csv);

			api.data = csv;
			api.dataLU = makeLookup(csv);

			Dispatch.dispatch.call('dataReady');

			// if(api.worldJson !== null)
			// 	checkAllCountryRowsAreInGeoJson(api.dataLU, api.worldJson);
		});

	}
};

export default api;




/** WEBPACK FOOTER **
 ** ./src/Model/Model.js
 **/